module AppKitchen {
    export module Controls {
        export module TimeseriesDataViews {

            // ReSharper disable once InconsistentNaming
            export interface TimeseriesDataSpreadsheetViewOptions extends AppKitchen.ViewBaseOptions {
                dateFormat?: string;
                editable?: boolean;
                onEdit?: () => void;
            }

            export class TimeseriesDataSpreadsheetView extends AppKitchen.ViewBase<TimeseriesDataViewModel> {
                options: TimeseriesDataSpreadsheetViewOptions;
                spreadSheet: kendo.ui.Spreadsheet;
                dirty: boolean;
                private updatesSuspended: boolean;

                constructor(model: TimeseriesDataViewModel, targetContainer: HTMLElement, options?: TimeseriesDataSpreadsheetViewOptions) {
                    super(model, targetContainer, AppKitchen.OptionsHelper.merge<TimeseriesDataSpreadsheetViewOptions>(options, {
                        editable: false,
                        onEdit: () => {}
                    }));

                    this.render();
                    this.updatesSuspended = false;
                    this.model.on("change:timeseries", () => {
                        if (!this.updatesSuspended) {
                            this.render();
                        }
                    });
                }

                render() {
                    AppKitchen.UIHelper.renderTemplateTo(this.el, Templates.TimeseriesDataSpreadsheetView);
                    var spreadsheetContainer = this.$el.find(".a-tssv-spreadsheet-container");

                    // header Row
                    var headerRow: kendo.ui.SpreadsheetSheetRow = <any>{
                        cells: [
                            {
                                value: "Zeitpunkt",
                                align: "right",
                                fontSize: 12.8,
                                fontFamily: "OpenSans",
                                color: AppKitchen.Colors.Gray,
                                borderBottom: { color: AppKitchen.Colors.LightGray, size: "2" },
                                enable: false
                            }]
                    }

                    this.model.get().timeseries.forEach(ts => {
                        headerRow.cells.push({
                            value: ts.label + " (" + ts.unit + ")",
                            color: ts.color,
                            borderBottom: { color: ts.color, size: "2" },
                            fontSize: 12.8,
                            fontFamily: "OpenSansSemiBold", enable: false
                        });
                    });

                    // data
                    var timeseries = this.model.get().timeseries;

                    if (timeseries.length > 1) {
                        this.synchronizeTimeseries(timeseries);
                    }

                    var sheetRowCount = !timeseries || timeseries.length === 0 || timeseries[0].data.length === 0 ? 1 : timeseries[0].data.length + 1;

                    var sheetColumns = [
                        { width: 150 }
                    ];

                    if (timeseries && timeseries.length > 0) {
                        for (let i = 0; i < timeseries.length; i++) {
                            sheetColumns.push({
                                width: timeseries[i].columnWidth || 150
                            });
                        }
                    }


                    this.spreadSheet = spreadsheetContainer.kendoSpreadsheet({
                        sheets: [
                            {
                                rows: [headerRow],
                                columns: sheetColumns,
                                frozenRows: !timeseries || timeseries.length === 0 || timeseries[0].data.length === 0 ? 0 : 1
                            }
                        ],
                        toolbar: false,
                        sheetsbar: false,
                        columns: sheetColumns.length,
                        rows: sheetRowCount
                    }).data("kendoSpreadsheet");

                    if (!timeseries || timeseries.length === 0 || timeseries[0].data.length === 0) {
                        return;
                    }

                    var sheet = this.spreadSheet.sheetByIndex(0);

                    var dateValues = timeseries[0].data.AsLinq().Select(tsData => [new Date(tsData[0])]).ToArray();
                    var dateRange = sheet.range("A2:A" + timeseries[0].data.length + 1);
                    dateRange.values(dateValues);

                    var dateFormat = kendo.culture().calendar.patterns.g;
                    if (this.options.dateFormat) {
                        if (kendo.culture().calendar.patterns[this.options.dateFormat]) {
                            dateFormat = kendo.culture().calendar.patterns[this.options.dateFormat];
                        } else {
                            dateFormat = this.options.dateFormat;
                        }
                    }

                    dateRange.format(dateFormat);
                    dateRange.enable(false);

                    var rowIndex = "B";
                    timeseries.forEach(ts => {
                        var values = ts.data.AsLinq().Select(tsData => [tsData[1]]).ToArray();
                        var valuesRange = sheet.range(rowIndex + "2:" + rowIndex + ts.data.length + 1);
                        valuesRange.values(values);
                        valuesRange.enable(this.options.editable);
                        if (ts.color) {
                            valuesRange.background(AppKitchen.UIHelper.Colors.lightenHex(ts.color, .9));
                        }
                        rowIndex = String.fromCharCode(rowIndex.charCodeAt(0) + 1);
                    });

                    this.addValidator(1, sheetRowCount - 1, sheetColumns.length - 1);

                    if (this.options.editable) {
                        this.spreadSheet.bind("change", () => {
                            this.dirty = true;
                            this.options.onEdit();
                        });
                    }

                    this.dirty = false;
                }

                private addValidator(numberOfHeaderRows: number, numberOfDataRows: number, numberOfDataColumns: number) {
                    var validator = <kendo.ui.SpreadsheetSheetRowCellValidation>{
                        from: "-999999999999",
                        to: "99999999999",
                        comparerType: "between",
                        type: "reject",
                        dataType: "number",
                        messageTemplate: AppKitchen.Strings.TimeseriesDataGrid_OnlyNumbers
                    };

                    (<any>this.spreadSheet.activeSheet().range("R" + (numberOfHeaderRows + 1) + "C2:R" + numberOfDataRows + numberOfHeaderRows + "C" + numberOfDataColumns+1)).validation(validator);
                }

                private suspendUpdates(action: () => void) {
                    var backup = this.updatesSuspended;
                    this.updatesSuspended = true;
                    action();
                    this.updatesSuspended = backup;
                }

                updateModel() {
                    if (this.options.editable) {
                        this.suspendUpdates(() => {
                            var data = this.model.get().timeseries;
                            if (!data || data.length === 0 || data[0].data.length === 0) {
                                return;
                            }

                            var sheet = this.spreadSheet.sheetByIndex(0);
                            var rowIndex = "B";

                            data.forEach(ts => {
                                var range = sheet.range(rowIndex + "2:" + rowIndex + ts.data.length + 1);

                                //TODO check if something changed at behavior

                                range.forEachCell((row: number, column: number, cell: any) => {
                                    let value = cell.value;
                                    ts.data[row][1] = typeof value == "number" ? value : null;
                                });

                                //var inputValues: number[][] = valuesRange.values();

                                //for (let i = 0; i < ts.data.length; i++) {
                                //    var value = inputValues[i][0];
                                //    if (typeof value == "number") {
                                //        ts.data[i][1] = value;
                                //    } else {
                                //        ts.data[i][1] = null;
                                //    }
                                //}
                                rowIndex = String.fromCharCode(rowIndex.charCodeAt(0) + 1);
                            });

                            this.model.trigger("change:timeseries", this.model);
                            this.dirty = false;
                        });
                    }
                }

                resize() {
                    this.spreadSheet.resize();
                }

                private synchronizeTimeseries(timeseries: TimeseriesDataViewData[]) {
                    if (timeseries.length > 1
                        && this.areTimeseriesFilled(timeseries)
                        && !this.areTimeseriesSynchroniezed(timeseries)) {
                        let timeseriesData = this.getSynchronizedTimeseriesData(timeseries);
                        this.updateTimeseriesData(timeseries, timeseriesData);
                    }
                }

                private updateTimeseriesData(timeseries: TimeseriesDataViewData[], data: number[][]) {
                    timeseries.forEach((t, i) => t.data = this.getTimesereisDataForIndex(data, i));
                }

                private getTimesereisDataForIndex(data: number[][], index: number): number[][] {
                    let resultData: number[][] = [];
                    data.forEach((d) => resultData.push([d[0], d[index + 1]]));
                    return resultData;
                }

                private getSynchronizedTimeseriesData(timeseries: TimeseriesDataViewData[]) : number[][] {
                    let currentIndex: number[] = [];
                    let minDate: number = Number.MAX_VALUE;
                    let increment: number = timeseries[0].data[1][0] - timeseries[0].data[0][0];
                    timeseries.forEach(() => currentIndex.push(0));
                    timeseries.forEach((t) => { if (t.data[0][0] < minDate) minDate = t.data[0][0]; });
                    let timesseriesData: number[][] = [];
                    let currentDate = minDate;
                    let running: boolean = true;
                    while (running) {
                        running = false;
                        let values: number[] = [];
                        values.push(currentDate);
                        timeseries.forEach((t, i) => {
                            if (currentIndex[i] < t.data.length) {
                                let date = t.data[currentIndex[i]][0];
                                let value = t.data[currentIndex[i]][1];
                                if (date === currentDate) {
                                    values.push(value);
                                    currentIndex[i]++;
                                } else {
                                    values.push(null);
                                }
                                running = true;
                            } else {
                                values.push(null);
                            }
                        });
                        timesseriesData.push(values);
                        currentDate += increment;
                    }
                    return timesseriesData;
                }

                private areTimeseriesFilled(timeseries: TimeseriesDataViewData[]): boolean {
                    if (!timeseries || !timeseries.length) {
                        return false;
                    }
                    for (let timeserie of timeseries) {
                        if (!timeserie.data || !timeserie.data.length) {
                            return false;
                        }
                    }
                    return true;
                }

                private areTimeseriesSynchroniezed(timeseries: TimeseriesDataViewData[]) {
                    let firstTimeserieDate = timeseries[0].data[0][0];
                    for (let timeserie of timeseries) {
                        let timeserieDate = timeserie.data[0][0];
                        if (firstTimeserieDate !== timeserieDate) {
                            return false;
                        }
                    }
                    return true;
                }
            }
        }
    }
}